import React, { HTMLAttributes } from 'react';

import { View } from '@uncinc/react-drupal-core';
import type {
  ImmutableEntity,
  ParagraphEntity,
} from '@uncinc/react-drupal-core/types';

import './style.scss';

interface ParagraphEventsFilteredProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<ParagraphEntity>;
}

const ParagraphEventsFiltered: React.FC<ParagraphEventsFilteredProps> = () => (
  <div className="Paragraph ParagraphEventsFiltered">
    <View
      className="row"
      id="events_filtered"
      display="events_filtered"
      storageType="url"
      withProvider
    />
  </div>
);

export default ParagraphEventsFiltered;
